const puzzle = {
  id: "0fdEQ14LP6vYDWaaftjU",
  name: "It's Tight In There",
  rebuses: [
    {
      clues: [
        {
          subtext: "",
          id: "06edebb4-b34a-44cf-919a-b1bf902c0f70",
          solutionInfo: {
            solvedText: "Weakest fundamental force",
            type: "text",
            possibleSolutions: [],
          },
          style: {
            width: "calc(70% - 10px)",
          },
          dependsOn: [],
          helperText: "",
          clueGroup: 0,
          clueValues: [
            {
              type: "image",
              id: "b4a49596-af42-4233-be06-145d3f1ec106",
              value: "CQtgl9KX.png",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
        },
      ],
      id: "17a6a99f-caa4-472d-96cb-4c95e8f444b8",
      style: {},
      solutionInfo: {
        possibleSolutions: [
          {
            value: "Gravity",
            id: "3896d25c-dc0c-4847-8f40-4b63ddfc8180",
          },
        ],
        type: "text",
        solvedText: "Gravity",
      },
    },
    {
      solutionInfo: {
        possibleSolutions: [
          {
            id: "c8b2f07a-2e86-4582-bc51-ece327ea970a",
            value: {
              minute: "",
              hour: "",
              place: "",
              second: "",
              year: "2019",
              day: "",
              month: "",
            },
          },
        ],
        solvedText: "2019.",
        type: "date",
      },
      clues: [
        {
          id: "6f3a43b3-5946-4e99-a04f-1f347d327f5d",
          style: {
            width: "calc(33% - 10px)",
          },
          clueValues: [
            {
              id: "4878d9fd-3c36-4af1-aad3-8b3ae5e558b9",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
              type: "image",
              value: "5ZEPtsbh.png",
            },
          ],
          solutionInfo: {
            possibleSolutions: [],
            solvedText: "",
            type: "text",
          },
          dependsOn: [],
          clueGroup: 0,
          subtext: "Cisterian",
          helperText:
            "Find cisterian numerals and figure out which number this symbol is representing.",
        },
      ],
      id: "ac95355d-de31-42e5-ac8c-858059dc1c1b",
      style: {},
    },
    {
      id: "691ef827-a016-4ef2-9ae0-bbd3c23300af",
      solutionInfo: {
        possibleSolutions: [
          {
            id: "c329de13-cf3b-439e-ad21-00c620ea817c",
            value: "Space",
          },
        ],
        solvedText: "Space",
        type: "text",
      },
      style: {},
      clues: [
        {
          clueGroup: 0,
          id: "11402fb1-c9e3-46a1-930a-de46fe15748a",
          subtext: "",
          helperText: "Arcade game released in 1979.",
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          clueValues: [
            {
              value: "Ps2fxE7j.png",
              id: "3d9087e4-0a29-44e9-8783-f4c911cd73cd",
              style: {
                width: "calc(100% - 10px)",
              },
              type: "image",
              subtext: "Old arcade game",
            },
          ],
          solutionInfo: {
            solvedText: "Asteroids",
            type: "text",
            possibleSolutions: [
              {
                value: "Asteroids",
                id: "d8d2c7f5-0306-41b1-961c-ff8a3a259064",
              },
            ],
          },
        },
        {
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          id: "c49c3c6b-a6f0-4c8b-8d29-fac62ab48ab1",
          subtext: "",
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                value: "Jam",
                id: "4d6815b6-c398-4b06-8b28-d15c28bf02e3",
              },
            ],
            solvedText: "Jam",
          },
          helperText: "Similar to jelly and marmalade. Jimmy Fallon game show.",
          clueValues: [
            {
              subtext: "",
              value: "Fruit preserve",
              type: "text",
              id: "ff42cad9-a1cd-4897-816f-10b9924fffa6",
              style: {
                width: "calc(100% - 10px)",
              },
            },
            {
              value: "A song one likes a lot",
              type: "text",
              id: "b5473494-c1d7-4c12-affa-0a79b39756d5",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
            {
              subtext: "",
              id: "5b88608c-3057-4e3c-be3b-79557093c788",
              value: "A thing becoming stuck",
              type: "text",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
        },
        {
          helperText:
            "If you're sitting at a computer, the answer is right in front of you.",
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              subtext: "",
              type: "text",
              id: "c3b121f1-ab02-4268-ba13-f98fdea99651",
              value: "Kevin Mitnick uses it a lot.",
              style: {
                width: "calc(100% - 10px)",
              },
            },
            {
              value: "It's friend is not a rat.",
              id: "d7d4d857-dac9-4808-8397-fa0dbb496db4",
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "",
              type: "text",
            },
          ],
          subtext: "",
          id: "8f7ca479-d787-4dc8-af0e-a947229e327a",
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                value: "Keyboard",
                id: "16498858-3404-47d4-8cae-5ea2095653a2",
              },
            ],
            solvedText: "Keyboard",
          },
          style: {
            width: "calc(33% - 10px)",
          },
        },
        {
          style: {
            width: "calc(33% - 10px)",
          },
          solutionInfo: {
            possibleSolutions: [],
            solvedText: "",
            type: "text",
          },
          dependsOn: [
            {
              value: "8f7ca479-d787-4dc8-af0e-a947229e327a",
              id: "2bb94c72-d8d2-44d0-9805-a18c98910340",
            },
            {
              id: "edf5b2b3-9229-4301-a16c-c46d374620f8",
              value: "c49c3c6b-a6f0-4c8b-8d29-fac62ab48ab1",
            },
            {
              value: "11402fb1-c9e3-46a1-930a-de46fe15748a",
              id: "8b206a1b-8ccd-428d-bcd9-785b810e2f6c",
            },
          ],
          id: "7de7ba3b-c01b-4653-881e-5b9d28fd4e8f",
          clueValues: [
            {
              style: {
                width: "calc(50% - 10px)",
              },
              subtext: "Asteroids",
              id: "1f7eb0c6-f29f-45a6-bc20-aa0b24fcc7bf",
              type: "text",
              value: "Location",
            },
          ],
          subtext: "",
          helperText: "Where can you find asteroids?",
          clueGroup: 0,
        },
        {
          dependsOn: [
            {
              id: "ce130932-258c-4cf9-b30b-f87115089e91",
              value: "8f7ca479-d787-4dc8-af0e-a947229e327a",
            },
            {
              id: "f04d7b22-0ed9-43a9-92cc-49719d6476d6",
              value: "c49c3c6b-a6f0-4c8b-8d29-fac62ab48ab1",
            },
            {
              id: "fceebc36-8030-47b1-b5fc-bdacead0e2b0",
              value: "11402fb1-c9e3-46a1-930a-de46fe15748a",
            },
          ],
          style: {
            width: "calc(33% - 10px)",
          },
          id: "323a37db-ea35-4aba-a4e9-62821089e959",
          helperText: "A movie starring Michael Jordan.",
          solutionInfo: {
            solvedText: "",
            type: "text",
            possibleSolutions: [],
          },
          clueValues: [
            {
              subtext: "Jam",
              type: "text",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "16400f2a-44e2-4707-9145-c26d8708afd6",
              value: "Movie (1996.)",
            },
          ],
          subtext: "",
          clueGroup: 0,
        },
        {
          dependsOn: [
            {
              id: "e916e41f-4a2b-4d1a-a7e5-2dda9fc2759d",
              value: "8f7ca479-d787-4dc8-af0e-a947229e327a",
            },
            {
              id: "46616a00-f4a7-4964-b706-97294a41168d",
              value: "c49c3c6b-a6f0-4c8b-8d29-fac62ab48ab1",
            },
            {
              value: "11402fb1-c9e3-46a1-930a-de46fe15748a",
              id: "470d5013-9fb4-478b-8a06-3d9529d2d413",
            },
          ],
          clueGroup: 0,
          clueValues: [
            {
              value: "Button",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "01c889d2-c045-4066-b73f-a6ef1f39c0e9",
              type: "text",
              subtext: "Keyboard",
            },
          ],
          style: {
            width: "calc(33% - 10px)",
          },
          id: "c074706c-1740-47c3-ac4a-c36571ca192d",
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
          helperText: "",
          subtext: "",
        },
      ],
    },
    {
      solutionInfo: {
        possibleSolutions: [
          {
            id: "37ec443a-c75d-4d98-8292-12a50a67e0fd",
            value: "Black hole",
          },
          {
            value: "Black holes",
            id: "19059bbe-f4a5-4c9d-b1ae-85b9ba45b8c5",
          },
        ],
        solvedText: "Black hole",
        type: "text",
      },
      clues: [
        {
          style: {
            width: "calc(33% - 10px)",
          },
          id: "09fbb5fa-706c-48e8-bda7-69a0564477de",
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              value: "Gravity",
              id: "c7aa2dcd-0633-4426-a2f4-8122ff40de96",
              subtext: "Not even light escapes it",
              type: "text",
            },
          ],
          subtext: "",
          helperText: "",
          dependsOn: [],
          clueGroup: 0,
        },
        {
          style: {
            width: "calc(33% - 10px)",
          },
          id: "11111111-706c-48e8-bda7-69a0564477de",
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              value: "2019.",
              id: "c7aa2dcd-0633-4426-a2f4-8122ff40de96",
              subtext: "First image",
              type: "text",
            },
          ],
          subtext: "",
          helperText: "",
          dependsOn: [],
          clueGroup: 0,
        },
        {
          style: {
            width: "calc(33% - 10px)",
          },
          id: "22222222-706c-48e8-bda7-69a0564477de",
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
          clueValues: [
            {
              style: {
                width: "calc(50% - 10px)",
              },
              value: "RL7Vmm5S.png",
              id: "c7aa2dcd-0633-4426-a2f4-8122ff40de96",
              subtext: "Space",
              type: "image",
            },
          ],
          subtext: "",
          helperText: "",
          dependsOn: [],
          clueGroup: 0,
        },
      ],
      style: {},
      id: "7fb69de4-4400-4f12-993f-5b04adccb01a",
    },
  ],
};

export default puzzle;
